var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card',{staticClass:"c-card"},[_c('v-card-title',{staticClass:"c-card__title"},[_c('h3',{staticClass:"c-title"},[_vm._v(" "+_vm._s(_setup.props?.dado?.tipo)+" "+_vm._s(_setup.props?.dado?.codigo)+" ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }